const LOWER = 'abcdefghijklmnopqrstuvwxyz';
const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const DIGITS = '0123456789';
const SYMBOLS = '!@#$%&*+-=?';

function secureIndex(max: number): number {
  const values = new Uint32Array(1);
  crypto.getRandomValues(values);
  return values[0] % max;
}

function pickChar(charset: string): string {
  return charset[secureIndex(charset.length)]!;
}

/** Genera una contraseña aleatoria con mayúsculas, minúsculas, números y símbolos. */
export function generateSecurePassword(length = 16): string {
  const size = Math.max(length, 12);
  const all = LOWER + UPPER + DIGITS + SYMBOLS;
  const chars = [pickChar(LOWER), pickChar(UPPER), pickChar(DIGITS), pickChar(SYMBOLS)];

  while (chars.length < size) {
    chars.push(pickChar(all));
  }

  for (let i = chars.length - 1; i > 0; i--) {
    const j = secureIndex(i + 1);
    [chars[i], chars[j]] = [chars[j]!, chars[i]!];
  }

  return chars.join('');
}
